module.exports = __webpack_public_path__ + "static/img/Anglian-Chem-5.20efe1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Anglian-Chem-5.jpg
// module id = 9d7X
// module chunks = 0